// extracted by mini-css-extract-plugin
module.exports = {"chartName":"index-chartName-3fBsN"};